import { render } from "./RecordList.vue?vue&type=template&id=69334352&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"

import "./RecordList.vue?vue&type=style&index=0&id=69334352&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69334352"]])

export default __exports__